import React from 'react';
import Skeleton from 'react-loading-skeleton';

import styles from './contract-iq-table.module.scss';

interface IContractIqRowSkeletonProps {
  className?: string;
}

export default function ContractIqRowSkeleton({ className }: IContractIqRowSkeletonProps) {
  return (
    <div className={`${styles.row} ${className ?? ''}`}>
      <div className={styles['col-fields']}>
        <Skeleton width="80%" height={20} />
      </div>
      <div className={styles['col-reason']}>
        <Skeleton width={90} height={24} />
      </div>
      <div className={styles['col-timestamp']}>
        <Skeleton width={140} height={20} />
      </div>
      <div className={styles['col-user']}>
        <Skeleton circle width={28} height={28} />
        <Skeleton width={100} height={20} />
      </div>
      <div className={styles['col-notes']}>
        <Skeleton width="60%" height={20} />
      </div>
    </div>
  );
}
